import { Component, ErrorInfo, ReactNode } from 'react'

import { SentryService } from '@/services/SentryService'

/** Shows what broke instead of a blank frame (a phone has no console to look at), and offers a reload. */
export class CrashScreen extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[pos crash]', error, info.componentStack)
    SentryService.captureException(error, { componentStack: info.componentStack })
  }

  render() {
    const { error } = this.state
    if (!error) return this.props.children
    return (
      <div className="grid min-h-dvh place-items-center bg-frame p-4">
        <div className="w-full max-w-md space-y-3 rounded-md bg-card p-5 text-sm">
          <h1 className="text-heading-md text-ink">Something went wrong</h1>
          <p className="text-muted-foreground">Nothing was lost: sales stay on this device. Reload to carry on.</p>
          <pre className="max-h-48 overflow-auto whitespace-pre-wrap break-words rounded-sm bg-fill p-2 font-mono text-xs text-ink">
            {error.name}: {error.message}
            {'\n'}
            {error.stack?.split('\n').slice(1, 6).join('\n')}
          </pre>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="h-10 w-full rounded-sm bg-primary font-medium text-white"
          >
            Reload
          </button>
        </div>
      </div>
    )
  }
}
